/**
 * Shared date range control for pump hub analytics tabs.
 */
import { buildAnalyticsPresets, daysBetween } from './adminAnalyticsDateUtils';

export default function AdminPumpAnalyticsDateBar({
  operationFrom = '',
  operationTo = '',
  draftFrom = '',
  draftTo = '',
  appliedFrom = '',
  appliedTo = '',
  activePresetKey = '',
  onDraftFromChange,
  onDraftToChange,
  onApply,
  onPreset,
}) {
  const presets = buildAnalyticsPresets(operationFrom, operationTo);
  const appliedDays = appliedFrom && appliedTo ? daysBetween(appliedFrom, appliedTo) : 0;
  const longRange = appliedDays > 365;
  const uniquePresetRanges = new Set(presets.map((p) => `${p.from_date}|${p.to_date}`));

  return (
    <div className="admin-panel admin-pump-hub__panel admin-pump-analytics-date-bar mb-0">
      <div className="admin-pump-analytics-presets mb-2">
        {presets.map((preset) => (
          <button
            key={preset.key}
            type="button"
            className={`btn btn-sm ${activePresetKey === preset.key ? 'btn-primary' : 'btn-outline-secondary'}`}
            onClick={() => onPreset(preset)}
            title={`${preset.from_date} → ${preset.to_date}`}
          >
            {preset.label}
          </button>
        ))}
      </div>
      <p className="small text-muted mb-2">
        Presets fill the from/to dates and apply immediately. Use Apply range after manual date edits.
      </p>

      {uniquePresetRanges.size < presets.length && (
        <p className="small text-muted mb-2">
          This pump&apos;s operating period is shorter than some presets — several buttons may use the same
          {operationFrom ? ` ${operationFrom} → ${operationTo || 'today'}` : ''} range.
        </p>
      )}

      <div className="row g-2 align-items-end">
        <div className="col-md-3">
          <label className="form-label small mb-1">From date</label>
          <input
            type="date"
            className="form-control form-control-sm"
            min={operationFrom || undefined}
            max={draftTo || operationTo || undefined}
            value={draftFrom}
            onChange={(e) => onDraftFromChange(e.target.value)}
          />
        </div>
        <div className="col-md-3">
          <label className="form-label small mb-1">To date</label>
          <input
            type="date"
            className="form-control form-control-sm"
            min={draftFrom || operationFrom || undefined}
            max={operationTo || undefined}
            value={draftTo}
            onChange={(e) => onDraftToChange(e.target.value)}
          />
        </div>
        <div className="col-md-2">
          <button type="button" className="btn btn-sm btn-primary w-100" onClick={onApply} disabled={!draftFrom || !draftTo || draftFrom > draftTo}>
            Apply range
          </button>
        </div>
      </div>

      {longRange && (
        <p className="small text-warning mb-0 mt-2">
          Long ranges ({appliedDays} days) can slow analysis and dilute trends — try Last 90 days for sharper insights.
        </p>
      )}
    </div>
  );
}
